export default __webpack_public_path__ + "static/media/highq_v2.4a8676aa.jpg";